import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import QuickbooksAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/QuickbooksAppIcon';

import DeprecatedTrackedLink from 'components/Common/Link/DeprecatedTrackedLink';

import Spacer20 from '../../../Misc/Spacer20.js';
import QboDialog from '../Dialogs/QuickbooksConnectDialog';
import QboButton from '../OtherComponents/QboButton';

const LINK_QUICKBOOKS_ONLINE_SIGNUP = 'https://quickbooks.intuit.com/partners/irp/?cid=irp-17855';

const QboStrategy = {
  previewInfo: {
    name: 'QuickBooks',
    iconSvg: <QuickbooksAppIcon size="xlarge" />,
    newTab: false,
  },
  headerInfo: {
    name: 'QuickBooks Online',
    category: 'Accounting',
    details: (
      <div>
        This App enables an ongoing one-way sync of jobs and customer data from your Housecall Pro account to your
        QuickBooks online account. We will automate all data entry so that you don&apos;t have to touch QuickBooks for
        jobs data again.
        <Spacer20 />
        You can also import your jobs and customer history if you are new customer by connecting to QuickBooks.
        <Spacer20 />
        Don’t have an account?{' '}
        <DeprecatedTrackedLink trackingName="sign_up" href={LINK_QUICKBOOKS_ONLINE_SIGNUP} target="_blank">
          Sign up for QuickBooks Online.
        </DeprecatedTrackedLink>
      </div>
    ),
    iconSvg: <QuickbooksAppIcon size="xlarge" />,
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/h1hnb60zuj?videoFoam=true',
  },
  sellingPoints: {
    headline: '',
    description: '',
    unorderedPoints: '',
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Not Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    title: 'Partner Pricing',
    hideToggle: true,
    appActionButton: <QboButton />,
    description: (
      <Grid container spacing={8}>
        <Grid item>
          <Typography align="left" variant="body1">
            <a href="https://quickbooks.intuit.com/partners/irp/?cid=irp-17855" target="_blank" rel="noreferrer">
              https://quickbooks.intuit.com/
            </a>
          </Typography>
        </Grid>
        <Grid item>
          <Typography align="center" color="textSecondary">
            This feature requires that you have a QuickBooks Essentials plan or higher, starting at $38.50/month.
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  supportContacts: [
    { type: 'Phone', contact: '(877) 683-3280' },
    {
      type: 'Support',
      contact: (
        <a href="https://help.quickbooks.intuit.com" target="_blank" rel="noreferrer">
          help.quickbooks.intuit.com
        </a>
      ),
    },
  ],
  dialog: <QboDialog />,
};

export default QboStrategy;
